import React from "react";
import { AlarmClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  label: string;
  tone?: "light" | "dark";
};
export function Countdown({
  label,
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    name: "Hours",
    value: hours
  }, {
    name: "Minutes",
    value: minutes
  }, {
    name: "Seconds",
    value: seconds
  }];
  const dark = tone === "dark";
  return <div className="flex w-full flex-col items-center" role="timer" aria-label={label} data-id="element-20" data-mp="3h0pgtkd9ntx6">
      <p className={`flex items-center gap-2 text-sm font-black uppercase tracking-wide ${dark ? "text-sun" : "text-coral"}`} data-id="element-21" data-mp="323q11989gurm">
        <AlarmClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-22" data-mp="3731iylkd66as" />
        {label}
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-23" data-mp="10cv0y570u9f3">
        {units.map((unit, i) => <React.Fragment key={unit.name} data-id="element-24" data-mp="15a4yy98h7tej" data-mpi={i}>
            {i > 0 && <span className={`pt-2 text-3xl font-black ${dark ? "text-white/60" : "text-navy/40"}`} aria-hidden="true" data-id="element-25" data-mp="y0n1tq0onbb3">
                :
              </span>}
            <div className="flex flex-col items-center" data-id="element-26" data-mp="17pya5afqwbxx">
              <span className={`flex h-16 w-[4.5rem] items-center justify-center rounded-xl text-4xl font-black tabular-nums ${dark ? "bg-white text-navy" : "bg-navy text-white"}`} data-id="element-27" data-mp="12rwpwm6l26kv">
                {String(unit.value).padStart(2, "0")}
              </span>
              <span className={`mt-1.5 text-[11px] font-extrabold uppercase tracking-wider ${dark ? "text-white/70" : "text-ink/60"}`} data-id="element-28" data-mp="o3igttikplvv">
                {unit.name}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}